(function () {
  class MinerView extends PIXI.Container {
    constructor() {
      super();

      this._minerAnim = undefined;
      this._idleAnim = undefined;

      this._canPlayIdle = false;

      this._tntExplosionAnims = [];

      this._layoutComplete = false;
    }

    /**
     * Anims Are:
     * Miner_Explode
     * Miner_Start
     * Miner_Travel
     * Miner_Travel_Back
     */

    /**
     * Basic flow is:
     * move miner
     * start miner
     * tnt blast & miner explode
     * drop symbols
     * then move miner back
     */
    initialise() {
      this._reel;

      this._minerContainer = resourceManager.get("MinerView");

      this._minerAnim = resourceManager.createObject(
        "spine",
        "minerSpine",
        this._minerContainer,
        { name: "MinerAnims", defaultAnimation: "Start" }
      );

      this._minerTimeline = undefined;
      this._minerHasMoved = false;

      let self = this;

      this._idleAnim = gsap.timeline({ repeat: -1 }).call(
        () => {
          self._minerAnim.play("Idle", false, 0, self.onIdle.bind(self));
        },
        undefined,
        "<+=5"
      );

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );

      this.addMessageListeners();
    }

    onLayoutComplete() {
      this._tntBlast = resourceManager.get("tntBlast");
      this._tntBlast.gotoAndStop(0);
      this._tntBlast.visible = false;

      this._layoutComplete = true;

      this.onOrientationChange();
      this.playIdleAnims();
      this.onIdle();
    }

    playIdleAnims() {
      this._canPlayIdle = true;
    }

    stopIdleAnims() {
      this._canPlayIdle = false;
      this._idleAnim.pause();
    }

    addMessageListeners() {
      messageBus.subscribe(
        "game:ModifierEvent",
        this.onModifierEvent.bind(this)
      );
    }

    getReelPosX(reel) {
      if (reel === undefined) return 0;

      return gameData.reels[reel].position.getX();
    }

    getReelWidth(reel) {
      if (reel === undefined) return 0;

      return gameData.reels[reel].width;
    }

    onModifierEvent(modifierEvent) {
      this._modifierEvent = modifierEvent;
      this._modifierEvent.join();

      this._reel = modifierEvent.data.reelToHide;
      this._symbolsToExplode = gameController
        .getExplosionAnims()
        [this._reel].slice(0, 3);

      this.moveMiner();
    }

    explodeTnt() {
      let replacementSymbols =
        this._modifierEvent.data.winningLineEvent.tntModifier
          .replacementSymbols;

      let self = this;

      this.setTntBlastX();

      this._tntBlast.visible = true;
      this._tntBlast.gotoAndPlay(0);
      this._tntBlast.onComplete = function () {
        self.explodeReel(self, replacementSymbols);
      };
    }

    onOrientationChange() {
      if (!this._layoutComplete) return;

      this.setTntBlastX();

      this._minerTimeline?.progress(1);
      this._minerAnim.x = this._minerHasMoved
        ? this.getMinerEndX()
        : this.getMinerStartX();

      this._minerAnimStartPosX = this.getMinerStartX();
    }

    setTntBlastX() {
      let xPos;

      switch (layoutController.getCurrentLayout()) {
        case "landscape_default":
          xPos =
            this.getReelPosX(this._reel) + this.getReelWidth(this._reel) / 2;
          break;
        case "landscape_mobile":
          xPos =
            (this.getReelPosX(this._reel) + this.getReelWidth(this._reel) / 2) *
            0.85;
          break;
        case "portrait_default":
        case "portrait_mobile":
          xPos =
            (this.getReelPosX(this._reel) + this.getReelWidth(this._reel) / 2) *
            0.74;
          break;
      }

      this._tntBlast.x = xPos;
    }

    getMinerStartX() {
      let xPos;

      switch (layoutController.getCurrentLayout()) {
        case "landscape_default":
        case "landscape_mobile":
          xPos = -66;
          break;
        case "portrait_default":
        case "portrait_mobile":
          xPos = -145;
          break;
      }

      return xPos;
    }

    getMinerEndX() {
      return this.getReelPosX(this._reel) - this.getReelWidth(this._reel) / 2;
    }

    explodeReel(self, replacementSymbols) {
      if (replacementSymbols.length === 3) {
        this._symbolsToExplode[2].gotoAndPlay(0);
        gameData.reels[this._reel].showSymbol(2, false);
      }

      gameData.reels[this._reel].showSymbol(0, false);
      gameData.reels[this._reel].showSymbol(1, false);

      this._symbolsToExplode[0].gotoAndPlay(0);
      this._symbolsToExplode[1].gotoAndPlay(0);

      this._symbolsToExplode[0].onComplete = function () {
        self.leaveBonus();
      };

      this._minerAnim.play("Explode", false, 0, this.moveMinerBack.bind(this));
    }

    moveMiner() {
      this._minerAnim.visible = true;

      this.stopIdleAnims();

      soundManager.play("minerExplode");

      this._minerAnim.play("Travel_Forward");
      this._minerHasMoved = true;

      let xPos = this.getMinerEndX();

      var duration = 0.5 + this._reel * 0.1;

      this._minerTimeline = gsap.timeline().to(this._minerAnim, {
        x: xPos,
        duration,
        onComplete: () => {
          this._minerAnim.play("Plunger", false, 0, this.explodeTnt.bind(this));
        },
      });
    }

    moveMinerBack() {
      this._minerAnim.play("Travel_Back", true);
      this._minerHasMoved = false;

      var duration = 0.5 + this._reel * 0.1;

      this._minerTimeline = gsap.timeline().to(this._minerAnim, {
        x: this._minerAnimStartPosX,
        duration,
        delay: 0,
        onComplete: () => {
          this._minerAnim.stop("Travel_Back");
          this.onIdle();
        },
      });
    }

    leaveBonus() {
      this._modifierEvent.leave();
    }

    onIdle() {
      this._idleAnim.play();
    }
  }

  create = function (json) {
    return new MinerView();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return [""];
  };

  resourceManager.registerObjectType(
    "MinerView",
    create,
    initialise,
    getFilesRequired
  );
})();
